import jwtDecode from 'jwt-decode';
import SuperFetch from './superFetch';
import { clearToken, clearLocalStorage } from '../helpers/utility';
import { history } from '../redux/store';
class FetchHelper {
  async httpRequest(method, url, body = null){
    const token = localStorage.getItem('id_token');
    var check = this.checkExpirity(token)
    if (check.error) {
      clearLocalStorage();
      window.location.reload("/");
      return { error: check.error, error_msg: check.error_msg};
    }
    return await SuperFetch(method, url, body).then(response => {
      if (response.ok) {
        return response.json().then(data => ({
          status: response.status,
          data: data,
        }))

      } else {
        return {
          error: response,
          status: response.status,
          error_msg: 'Server Error'
        };
      }
    });
  }
  checkExpirity = token => {
    if (!token) {
      return { error: true, error_msg: 'No Token'};
    }

    const profile = jwtDecode(token);
    const expiredAt = profile.expiredAt || profile.exp * 1000;
    if (expiredAt > new Date().getTime()) {
      return {
        ...profile,
        token,
        expiredAt: new Date(expiredAt),
      };
    } else {
      return { error: true, error_msg: 'Token expired'};
    }
  };
}
export default new FetchHelper();
